
<template>
  <div v-if="!mobileAppActive" class="form-header"
    v-bind:class="{ 'radious-active': radiousActive, 'dark': theme === 'dark', 'light': theme === 'light', 'blue': theme === 'blue' }">
    <div class="inner-form-header columns is-gapless is-mobile">
      <template v-if="postLoginDialogActive">
        <div class="column is-10">{{ title }}</div>
      </template>
      <template v-if="!postLoginDialogActive">
        <template v-if="$isDesktop">
          <template v-if="theme === 'dark'">
            <div class="column is-middle is-3" id="logo" v-if="logoActive">
              <router-link :to="{ name: 'HomePage' }">
                <div class="eureko-logo-white"></div>
                <img v-if="affinityImgUrl" class="separator">
                <img v-if="affinityImgUrl" :src="affinityImgUrl" class="partner-img" :alt="affinityTitle">
              </router-link>
            </div>
            <div ref="formHeaderTitle" class="column has-text-centered"
              v-bind:class="{ 'is-6': logoActive, 'is-9': !logoActive }">
              <span>{{ title }}</span>
            </div>
          </template>
          <template v-if="theme === 'light'">
            <div ref="formHeaderTitle" class="column is-9 desktop-light-text">
              <!-- <span>{{title}}</span> -->
            </div>
          </template>
          <template v-if="theme === 'blue'">
            <div ref="formHeaderTitle" class="column is-9 desktop-light-text">
            </div>
          </template>
        </template>
        <template v-if="!$isDesktop">
          <div class="column is-middle is-2 cropped-logo" id="logo" v-if="logoActive">
            <div class="eureko-logo-white"></div>            
          </div>
          <div ref="formHeaderTitle" class="column" v-bind:class="{ 'is-11': !logoActive, 'is-9': logoActive }">
            <span>{{ title }}</span>
          </div>
        </template>
      </template>

      <div class="column"
        v-bind:class="{ 'is-1': !$isDesktop, 'is-3': $isDesktop && menuActive, 'is-2': $isDesktop && !menuActive }">
        <template v-if="!removeCloseIcon">
          <template v-if="theme === 'light'">
            <div id="close" class="is-pulled-right" v-on:click="$emit('clicked')">
              <div class='light' v-bind:class="{ 'close-icon-black': $isDesktop, 'close-icon-blue': $isMobile }"></div>
            </div>
          </template>
          <template v-if="theme === 'blue'">
            <div id="close" class="is-pulled-right" v-on:click="$emit('clicked')">
              <div class='blue' v-bind:class="{ 'close-icon': $isDesktop, 'close-icon-blue': $isMobile }"></div>
            </div>
          </template>
        </template>
        <template v-if="theme === 'dark' && $isDesktop && isLoginActive">
          <div class="column is-narrow is-middle is-pulled-right">
            <PostHeader />
          </div>
        </template>
        <template v-if="closeActive || (theme === 'dark' && !$isDesktop)">
          <template v-if="!menuActive">
            <div id="close" class="is-pulled-right" v-on:click="$emit('clicked')">
              <div class='close-icon'></div>
            </div>
          </template>
          <template v-if="menuActive">
            <dropdown trigger="click">
              <div class="is-pulled-right menu-3dot-icon-cover">
                <a class="menu-3dot-icon is-pulled-right"></a>
              </div>
              <div slot="content">
                <menus>
                  <li>
                    <span>
                      <a v-on:click.stop="redirectToHome($event)" class="router-link-exact-active router-link-active">{{
                        $t("links.redirectToHome") }}</a>
                    </span>
                  </li>
                  <template v-if="isLoginActive">
                    <div class="divider"></div>
                    <li>
                      <span>
                        <a v-on:click.stop="$router.push({ name: 'Personal' })"
                          class="router-link-exact-active router-link-active">{{ $t("buttons.account") }}</a>
                      </span>
                    </li>
                  </template>
                  <template v-if="!isClaim">
                    <div class="divider"></div>
                    <li>
                      <span>
                        <a v-on:click.stop="renew($event)" class="router-link-exact-active router-link-active">{{
                          $t("links.buyInsuranceAgain") }}</a>
                      </span>
                    </li>
                  </template>
                </menus>
              </div>
            </dropdown>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import PostHeader from '@/desktop/widget/post/PostHeader'
export default {
  name: 'PopupHeader',
  components: {
    PostHeader
  },
  data () {
    return {
      affinityImgUrl: '',
      affinityTitle: '',
      mobileAppActive: false
    }
  },
  props: {
    assistantActive: {
      default: false,
      type: Boolean
    },
    assistantNavPath: {
      default: '',
      type: String
    },
    theme: {
      default: 'dark',
      type: String
    },
    title: String,
    menuActive: {
      default: true,
      type: Boolean
    },
    postLoginDialogActive: {
      default: false,
      type: Boolean
    },
    logoActive: {
      default: true,
      type: Boolean
    },
    closeActive: {
      default: false,
      type: Boolean
    },
    radiousActive: {
      default: false,
      type: Boolean
    },
    isClaim: {
      default: false,
      type: Boolean
    },
    removeCloseIcon: {
      default: false,
      type: Boolean
    }
  },
  mounted () {
    var self = this
    self.mobileAppActive = self.theme === 'dark' ? this.isMobileApp() : false

    service.content.getAffinity(this).then(function (result) {
      if (result !== null) {
        self.affinityTitle = result.title
        self.affinityImgUrl = result.url
      }
    })
  },
  computed: {
    isLoginActive () {
      return this.isLogin()
    }
  },
  methods: {
    renew: function () {
      this.$emit('renew')
    },
    redirectToHome: function () {
      this.$emit('clicked')
      this.$emit('close')
      this.$router.push({ name: 'HomePage' })
    }
  }
}
</script>
<style scoped>
.menu-3dot-icon-cover {
  width: 100%;
  /*Do not remove -px, it is added for 5S small screen touch */
  margin-right: -15px;
  padding-right: 15px;
  margin-top: -15px;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: -15px;
}

.radious-active {
  border: 2px solid transparent;
  border-radius: 6px 6px 0 0;
}

.light {
  background-color: var(--light-bg1)
}

.light .inner-form-header {
  color: var(--eureko-blue)
}

.dark {
  background-color: var(--eureko-blue);
}

.blue {
  background-color: var(--eureko-blue);
}

.radious-active.dark {
  background-color: var(--text-color4);
}

.form-header {
  width: 100%;
  z-index: 10;
  padding: 0.938em 0.938em 1.063em 0.938em;
}

.inner-form-header {
  width: 100%;
  justify-content: center;
  font-weight: normal;
  letter-spacing: -0.4px;
  color: #ffffff;
}

.inner-form-header a {
  color: var(--light-bg1);
  font-size: 0.750em;
  font-weight: normal;
  line-height: 2;
  letter-spacing: -0.3px;
  text-align: right;
  color: var(--text-color4);
  text-decoration: underline;
}

.desktop-light-text {
  /*padding: 30px 15px 15px 15px !important;*/
  padding: 0px !important;
  color: var(--text-color1);
  font-weight: 600;
}

.close-icon {
  border: 5px solid transparent;
  border-top: none;
  cursor: pointer;
}

.popover-button {
  background-color: var(--eureko-blue);
  border: none;
  float: right;
}

#logo .logo-img {
  margin-left: 10px;
}

#logo a {
  text-decoration: none;
}

.cropped-logo img {
  position: absolute;
  clip: rect(0px, 45px, 200px, 0px);
  top: 10px;
}

.separator {
  background: #cee3ea;
  width: 1px;
  height: 45px !important;
  border: 0;
  margin: -7px 10px;
}
</style>
<style>
.tooltip {
  width: 150px;
  height: 114px;
  background-color: var(--text-color4);
  box-shadow: 0 8px 16px 0 rgba(89, 113, 138, 0.5);
  color: var(--eureko-blue);
  padding: 0;
  line-height: 56px;
}

.popover-inner {
  font-size: 15px;
  font-weight: 600;
}

.popover-inner div:first-child {
  border-bottom: 1px solid var(--border-color1);
}

.popover-inner div:first-child span {
  margin: 0 15px;
}

.popper-dropdown {
  width: 164px;
  /*height: 114px;*/
  background-color: var(--text-color4);
  box-shadow: 0 8px 16px 0 rgba(89, 113, 138, 0.5);
  color: var(--eureko-blue);
  padding: 0;
  font-size: 15px;
  font-weight: 600;
  border-radius: 5px 0 5px 5px;

  margin-top: -10px !important;
  top: 14px !important;
  left: -10px !important;
}

.popper-dropdown::after {
  content: " ";
  position: absolute;
  bottom: 100%;
  right: 0;
  margin-left: -5px;
  border-width: 4px;
  border-style: solid;
  border-color: transparent var(--text-color4) var(--text-color4) transparent;
}

.popper-dropdown .menu-list a {
  color: var(--eureko-blue);
  padding: 0 14px;
  line-height: 48px;
  opacity: 1;
}

.popper-dropdown .menu-list span {
  font-size: 15px;
  font-weight: 500;
}

.popper-dropdown .menu-list .divider {
  height: 1px;
  margin: 0;
  background-color: var(--border-color1);
}

.close-icon-blue {
  cursor: pointer;
}

.close-icon-black {
  width: 15px;
  height: 15px;
  background-position: center;
  background-size: 15px;
  cursor: pointer;
}

.inner-form-header .cropped-logo a {
  font-size: initial;
}
</style>



// WEBPACK FOOTER //
// src/shared/widget/popupHeader.vue